import { Component, OnInit } from '@angular/core';
import { OurProjectService } from '../../services/our-project.service';
import { OurProjectsModel } from '../../models/our-projects.model';

@Component({
  selector: 'app-job-list-two',
  templateUrl: './job-list-two.component.html',
  styleUrls: ['./job-list-two.component.css']
})
export class JobListTwoComponent implements OnInit {
currentLang = localStorage.getItem('lang') || 'ar';

    constructor(private ourProjectService: OurProjectService) { }
  ourprojects: OurProjectsModel[] = [];
    ngOnInit(): void {
      this.ourProjectService.getAll().subscribe((res: any) => {
        this.ourprojects = res;
      });
    
    }
    // Set Topbar Option
    Menuoption = 'job';
  Settingicon = true
  footerVariant = 'bg-light';
  navClass = "nav-light";
}
